module.exports = __webpack_public_path__ + "img/grey.02a07781.svg";